import { render, staticRenderFns } from "./RichContentEditor.vue?vue&type=template&id=600f5b4d&scoped=true"
import script from "./RichContentEditor.vue?vue&type=script&lang=js"
export * from "./RichContentEditor.vue?vue&type=script&lang=js"
import style0 from "./RichContentEditor.vue?vue&type=style&index=0&id=600f5b4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600f5b4d",
  null
  
)

export default component.exports